import { PrintType } from '@/types';

export function getIsSingleConfigurationPrintType(printType: PrintType) {
  return printType.restrictions.printableAlongWithPrintTypes.length === 0;
}
